import * as React from 'react';

const paymentsUIContextValues = {
    isProcessingOrder: false,
    setIsProcessingOrder: ()=>null
    ,
    paymentQRCodeState: undefined,
    setPaymentQRCodeState: ()=>null
    ,
    isQrCodeModalOpen: false,
    setIsQrCodeModalOpen: ()=>null
    ,
    currentCardBrand: undefined,
    setCurrentCardBrand: ()=>null
};
const PaymentsUIContext = /*#__PURE__*/ React.createContext(paymentsUIContextValues);
const usePaymentsUIContext = ()=>{
    const context = React.useContext(PaymentsUIContext);
    if (context === paymentsUIContextValues) {
        throw new Error('No PaymentUI Context available. You might still need to wrap the application with the paymentUIContextProvider component.');
    }
    return context;
};
PaymentsUIContext.displayName = 'PaymentsUIContext';
PaymentsUIContext.Consumer;

export { PaymentsUIContext, usePaymentsUIContext };
//# sourceMappingURL=context.js.map
